import { ProjectTodo } from '../ducks';

// Pick a sort_order for a row landing at `targetIdx` inside `siblings` (the
// sibling list *without* the moved row). Uses midpoint between neighbors
// when both have explicit orders; otherwise anchors to whichever neighbor
// has one. Fallback is the plain index — fine for the first reorder on a
// project whose rows still have server-assigned null sort_orders.
export function pickSortOrder(siblings: ProjectTodo[], targetIdx: number): number {
  const prevOrder = targetIdx > 0 ? siblings[targetIdx - 1]?.sort_order ?? null : null;
  const nextOrder =
    targetIdx < siblings.length ? siblings[targetIdx]?.sort_order ?? null : null;
  if (prevOrder !== null && nextOrder !== null) return (prevOrder + nextOrder) / 2;
  if (prevOrder !== null) return prevOrder + 1;
  if (nextOrder !== null) return nextOrder - 1;
  return targetIdx;
}
